export const STRIPE_FEES = 3; //%
export const COMMISSION = 10; //%

export const costToProducer = (driverPayment) => {
  return Math.floor(
    (driverPayment + (driverPayment * (STRIPE_FEES + COMMISSION)) / 100) * 100
  );
};
